import { render } from "./PushNotifications.vue?vue&type=template&id=2b5f41a0&scoped=true"
import script from "./PushNotifications.vue?vue&type=script&lang=js"
export * from "./PushNotifications.vue?vue&type=script&lang=js"

import "./PushNotifications.vue?vue&type=style&index=0&id=2b5f41a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5f41a0"]])

export default __exports__